import React from 'react';
import { Link } from 'react-router-dom';
import TraderQuizShell from './TraderQuizShell';
import {
  ARCHETYPES,
  ARCHETYPE_PUBLIC_OVERVIEWS,
  PROFILE_CARD_ORDER_KEYS,
  getQuizArchetypeImageSrc,
} from '../data/quizData';
import '../components/Quiz/Quiz.css';

const ordered = PROFILE_CARD_ORDER_KEYS.map((k) => ARCHETYPE_PUBLIC_OVERVIEWS[k]).filter(Boolean);

const TraderQuizProfiles = () => {
  return (
    <TraderQuizShell>
      <div
        className="quiz-shell quiz-shell-page-inset mx-auto px-3 px-md-4 pb-4"
        style={{ maxWidth: 960 }}
      >
        <h1 className="h3 text-light fw-bold mb-2">Trader Archetypes</h1>
        <p className="text-muted mb-4">
          Below is an overview of the archetypes this quiz maps to—including a balanced “low dysfunction” profile when
          no theme dominates. Your detailed results, full write-up, and tool ideas show up once you complete the quiz.
        </p>

        <section className="quiz-profiles-quiz-cta mb-4 mb-md-5 pb-2 text-center">
          <h2 className="h5 text-light mb-3">See your real profile</h2>
          <Link to="/quiz" className="btn btn-primary btn-lg px-5">
            Take the FREE Quiz
          </Link>
        </section>

        <div className="quiz-profiles-grid">
          {ordered.map((item) => {
            const img = getQuizArchetypeImageSrc(item.key);
            const title = ARCHETYPES[item.key]?.title ?? item.headline;
            return (
              <Link
                key={item.key}
                to={`/quiz/profiles/${item.key}`}
                className="quiz-profile-card-link text-decoration-none h-100"
              >
                <article className="quiz-results-panel quiz-profile-card quiz-profile-card--teaser h-100 text-start">
                  {img ? (
                    <img
                      src={img}
                      alt=""
                      className="quiz-profile-card-img mb-3"
                      width={120}
                      height={120}
                    />
                  ) : null}
                  <h2 className="h6 text-light mb-2">{title}</h2>
                  <p className="small text-muted mb-0">{item.blurb}</p>
                </article>
              </Link>
            );
          })}
        </div>
      </div>
    </TraderQuizShell>
  );
};

export default TraderQuizProfiles;
